export default "__VITE_ASSET__Bi__aiU9__"